<template>
  <div class="content-block" data-aos="fade">
    <div class="container">
      <div class="row justify-content-center align-items-center">
        <div class="col-lg-10 col-md-12">
          <slot></slot>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data () {
    return {}
  }
}
</script>

<style lang="scss" scoped>
/*------------------------------------*\
  #PRIMARY COLOURS
\*------------------------------------*/
@import '../styles/colors';

/*------------------------------------*\
  #Mixins
\*------------------------------------*/

/*------------------------------------
  #MEDIA SCREENS < 768px (#MOBILE FIRST)
\*------------------------------------*/
.content-block {
  padding: 2rem;
  width: 100%; //flexbug

  strong {
    font-weight: 500;
  }

  &--full-height {
    text-align: left;
    .row {
      min-height: 100vh;
    }
  }

  &--third-height {
    text-align: left;
    padding: 0rem 1rem;
    .row {
      min-height: 33.4vh;
    }
  }

  &__img {
    display: block;
    margin: 1rem auto;
  }
}

/*------------------------------------*\
  #MEDIA SCREENS > 767px (TABLETS)
\*------------------------------------*/
@media (min-width: 767px) {
  .content-block {
    font-size: 1.7rem;
    font-weight: 300;
    &--full-height {
      text-align: left;
      font-size: 2rem;
      font-weight: 100;
      .row {
        min-height: 100vh;
        // F-F-f-ff-f-FLEXBUG
        &::after {
          content: '';
          min-height: inherit;
          font-size: 0;
        }
      }
    }

    &--half-height {
      text-align: left;
      font-size: 2rem;
      font-weight: 100;
      .row {
        min-height: 50vh;
      }
    }
  }
}

/*------------------------------------*\
  #MEDIA SCREENS > 992px
  (LAPTOP, TABLET)
\*------------------------------------*/
@media (min-width: 992px) {
}

/*------------------------------------*\
  #MEDIA SCREENS > 1200px (DESKTOP)
\*------------------------------------*/
@media (min-width: 1200px) {
}

/*------------------------------------*\
  #MEDIA SCREENS > 1320px (DESKTOP)
\*------------------------------------*/
@media (min-width: 1320px) {
}

/*------------------------------------*\
  #MEDIA SCREENS > 1600px (DESKTOP)
\*------------------------------------*/
@media (min-width: 1600px) {
}
</style>
